"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphFrame = exports.LayoutColumn = void 0;
var tslib_1 = require("tslib");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var list_1 = require("@devexpress/utils/lib/utils/list");
var LayoutColumn = (function (_super) {
    tslib_1.__extends(LayoutColumn, _super);
    function LayoutColumn() {
        var _this = _super.call(this, 0, 0, 0, 0) || this;
        _this.rows = [];
        _this.paragraphFrames = [];
        _this.tablesInfo = [];
        return _this;
    }
    LayoutColumn.prototype.getEndPosition = function () {
        return this.pageAreaOffset + list_1.ListUtils.last(this.rows).getEndPosition();
    };
    LayoutColumn.prototype.getLastRow = function () {
        return list_1.ListUtils.last(this.rows);
    };
    LayoutColumn.findSectionColumnWithMinimumWidth = function (columnBounds) {
        return list_1.ListUtils.min(columnBounds, function (a) { return a.width; }).width;
    };
    LayoutColumn.prototype.deepCopy = function () {
        var obj = new LayoutColumn();
        obj.pageAreaOffset = this.pageAreaOffset;
        obj.paragraphFrames = list_1.ListUtils.shallowCopy(this.paragraphFrames);
        obj.tablesInfo = list_1.ListUtils.shallowCopy(this.tablesInfo);
        obj.rows = list_1.ListUtils.shallowCopy(this.rows);
        obj.copyFrom(this);
        return obj;
    };
    return LayoutColumn;
}(rectangle_1.Rectangle));
exports.LayoutColumn = LayoutColumn;
var ParagraphFrame = (function (_super) {
    tslib_1.__extends(ParagraphFrame, _super);
    function ParagraphFrame() {
        var _this = _super.call(this, 0, 0, 0, 0) || this;
        _this.paragraphColor = 0;
        return _this;
    }
    ParagraphFrame.prototype.equals = function (obj) {
        return _super.prototype.equals.call(this, obj) &&
            this.paragraphColor == obj.paragraphColor;
    };
    ParagraphFrame.prototype.clone = function () {
        var res = new ParagraphFrame();
        res.copyFrom(this);
        res.paragraphColor = this.paragraphColor;
        return res;
    };
    return ParagraphFrame;
}(rectangle_1.Rectangle));
exports.ParagraphFrame = ParagraphFrame;
